module.exports = {
  toolbar: {
    title: 'Oversikt over enheter og besøk'
  }
}
